import { MAX_PAGE_SIZE } from '@debbie/common/dist/index.js';
import { IAM, drainPages } from '../apis.js';
const reqIAM = IAM('/users');
// Pages to the end: the endpoint caps pageSize at MAX_PAGE_SIZE, and a large
// tenant can hold more users than one page.
export const getAll = () => drainPages((page) => reqIAM('GET', `/?page=${page}&pageSize=${MAX_PAGE_SIZE}`), MAX_PAGE_SIZE);
export const getById = (id) => reqIAM('GET', `/${id}`);
export const update = (id, updated) => reqIAM('PATCH', `/${id}`, { body: updated });
export const create = (user) => reqIAM('POST', `/`, { body: user });
export const addCreditor = (id, relation) => reqIAM('POST', `/${id}/creditors`, { body: relation });
export const removeCreditor = (id, creditorId) => reqIAM('DELETE', `/${id}/creditors/${creditorId}`);
export const addTenant = (id, relation) => reqIAM('POST', `/${id}/tenants`, { body: relation });
export const removeTenant = (id, tenantId) => reqIAM('DELETE', `/${id}/tenants/${tenantId}`);
export const deleteUserById = (id) => reqIAM('DELETE', `/${id}`);
export const archiveUserById = (id) => reqIAM('POST', `/${id}/archive`, { body: {} });
export const unarchiveUserById = (id) => reqIAM('POST', `/${id}/unarchive`, { body: {} });
export const resendInviteToUser = (id) => reqIAM('POST', `/${id}/resend-invite`, { body: {} });
//# sourceMappingURL=users.js.map